










import { computed, defineComponent } from '@vue/composition-api';
import { PrismEditor } from 'vue-prism-editor';
import { languages } from 'prismjs';
import 'prismjs/components/prism-json';
import { highlight } from 'prismjs/components/prism-core';

export default defineComponent({
    name: 'JsonEditor',
    components: { PrismEditor },
    model: {
        prop: 'code',
        event: 'change',
    },
    props: {
        code: {
            type: String,
        },
        lineNumbers: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    setup: (props, { emit }) => {
        const textInEdit = computed({
            get: (): string => props.code || '',
            set: (updatedText: string) => emit('change', updatedText),
        });
        const highlighter = (code: string) => {
            return highlight(code, languages.json);
        };

        return { textInEdit, emit, highlighter };
    },
});
